import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { SecondarySolidButton } from '@bibliocommons/base-buttons';
import { catalogBibShape, bibShape, libraryShape } from '@bibliocommons/bc-prop-types';

import RedirectActions from 'app/actions/RedirectActions';
import { convertMetadataIdToLegacyId } from 'app/helpers/bib/bibHelpers';
import { SuggestForPurchaseInfo } from '../SuggestForPurchaseInfo';

import './PremiumSuggestionButton.scss';

export default function PremiumSuggestionButton({ bib, catalogBib, currentLibrary, premiumSuggestionsSummary }) {
  const premiumPatronSuggestionsAllowed = currentLibrary.getIn([
    'suggestForPurchase',
    'premium',
    'allowPatronSuggestions'
  ]);
  const dispatch = useDispatch();

  function handleOpen() {
    const title = catalogBib.getIn(['brief', 'title']);
    const isbn = bib.getIn(['briefInfo', 'isbns', 0]);
    const author = catalogBib.getIn(['brief', 'creators', 0, 'fullName']);
    const libBibId = convertMetadataIdToLegacyId(catalogBib.get('metadataId'));

    dispatch(
      RedirectActions.redirect('/suggested_purchases', {
        authRequired: true,
        method: 'POST',
        data: { title, isbn, author, libBibId }
      })
    );
  }

  function renderContent() {
    const totalSuggestionsThisMonth = premiumSuggestionsSummary.get('totalSuggestionsThisMonth');
    const suggestionsLimit = premiumSuggestionsSummary.get('suggestionsLimit');
    const isAboveLimit = !!totalSuggestionsThisMonth && totalSuggestionsThisMonth >= suggestionsLimit;

    if (!premiumPatronSuggestionsAllowed) {
      return <SuggestForPurchaseInfo message={<FormattedMessage id="patron_suggestions_not_allowed" />} />;
    }

    if (isAboveLimit) {
      return <SuggestForPurchaseInfo message={<FormattedMessage id="reach_suggestion_limit" />} />;
    }

    return (
      <SecondarySolidButton handleClick={handleOpen} dataKey="premium-suggestion-button" block>
        <FormattedMessage id="suggest_for_purchase" />
      </SecondarySolidButton>
    );
  }

  return <div className="cp-premium-suggestion-button">{renderContent()}</div>;
}

PremiumSuggestionButton.propTypes = {
  bib: bibShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  currentLibrary: libraryShape.isRequired,
  premiumSuggestionsSummary: ImmutablePropTypes.map.isRequired
};
